"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _MfaLien = require("./MfaLien");

var _MfaBouton = require("./MfaBouton");

var _MfaDialogue = require("./MfaDialogue");

require("../css/mfa-entete-fil-ariane.css");

var _dist = require("../../dist");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaEnteteFilAriane = /*#__PURE__*/function (_Component) {
  _inherits(MfaEnteteFilAriane, _Component);

  var _super = _createSuper(MfaEnteteFilAriane);

  function MfaEnteteFilAriane(props) {
    var _this;

    _classCallCheck(this, MfaEnteteFilAriane);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "confirmerFermetureSession", function () {
      _this.setState({
        afficherFermetureAvert: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "annulerFermetureSession", function () {
      _this.setState({
        afficherFermetureAvert: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fermerSession", function () {
      _this.setState({
        afficherFermetureAvert: false
      });

      _this.props.fermerSession();
    });

    _this.state = {
      routeHistory: [],
      afficherFermetureAvert: false
    };
    _this.ajouterRoute = _this.ajouterRoute.bind(_assertThisInitialized(_this));
    _this.obtenirIndexCourant = _this.obtenirIndexCourant.bind(_assertThisInitialized(_this));
    _this.obtenirRoute = _this.obtenirRoute.bind(_assertThisInitialized(_this));
    _this.remplacerRoute = _this.remplacerRoute.bind(_assertThisInitialized(_this));
    _this.retourRoute = _this.retourRoute.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MfaEnteteFilAriane, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var parents = [];
      var indexCourant = this.obtenirIndexCourant(this.props.location.key);
      var historiqueCourant = undefined;
      var routeCourante = undefined;
      var pageLocation = this.props.location.pathname; //Si un historique existe

      if (indexCourant > -1) {
        // Sauvegarde le ROUTER HISTORY au cas d'un F5 ou RECHARGEMENT DE LA PAGE (MES-1153 & MES-1267)
        sessionStorage.setItem('F5_ROUTER_HISTORY', JSON.stringify(this.state.routeHistory));
        routeCourante = this.state.routeHistory[indexCourant].route;
        historiqueCourant = routeCourante; //On arrête quand on tombe sur une page du menu

        while (historiqueCourant && !historiqueCourant.estLienMenu && !historiqueCourant.chemin == pageLocation && indexCourant > 0) {
          indexCourant--;
          historiqueCourant = this.state.routeHistory[indexCourant].route; //On n'ajoute pas la page par défaut, car elle est équivalente à la page d'Accueil ajoutée plus bas

          if (!historiqueCourant.estDefaut) {
            parents.unshift(historiqueCourant);
          }
        }
      } // Ajouter ELSE (MES-1153 & MES-1267)
      else {
          // Aucun historique dans la composante Route
          // Appel de la page: Premier chargement ou F5
          if (this.props.location.pathname != '/') {
            routeCourante = this.obtenirRoute(this.props.location.pathname);
            historiqueCourant = routeCourante;
            var routeHistoryStorage = undefined;

            if (typeof sessionStorage.F5_ROUTER_HISTORY !== "undefined") {
              routeHistoryStorage = {};
              routeHistoryStorage = JSON.parse(sessionStorage.F5_ROUTER_HISTORY);
            }

            while (historiqueCourant && !historiqueCourant.estLienMenu && !historiqueCourant.chemin == pageLocation && indexCourant > 0) {
              indexCourant--;
              historiqueCourant = routeHistoryStorage[indexCourant].route; //On n'ajoute pas la page par défaut, car elle est équivalente à la page d'Accueil ajoutée plus bas

              if (!historiqueCourant.estDefaut) {
                parents.unshift(historiqueCourant);
              }
            }
          }
        }

      var acceuil = undefined; //Si aucun historique ou la page courante est celle par défaut, on met l'accueil comme page actuelle

      if (!routeCourante || routeCourante.estDefaut) {
        routeCourante = this.obtenirRoute('/');
        acceuil = routeCourante;
      } //Sinon, on ajoute toujours l'accueil
      else {
          acceuil = this.obtenirRoute('/');
          parents.unshift(this.obtenirRoute('/'));
        } //Dans le cas ou il y a un site racine a renvoyer


      if ((0, _dist.estDefini)(acceuil.parent)) {
        parents.unshift(acceuil.parent);
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "filArianeConteneur"
      }, /*#__PURE__*/_react.default.createElement("ol", {
        className: "filAriane"
      }, parents.map(function (route, i) {
        if (route.urlRedirect) {
          return /*#__PURE__*/_react.default.createElement("li", {
            key: "fil-ariane-".concat(i)
          }, /*#__PURE__*/_react.default.createElement(_MfaLien.MfaLien, {
            href: route.chemin,
            redirect: true
          }, /*#__PURE__*/_react.default.createElement("span", null, route.description)));
        } //Si c'est la page d'accueil, on redirige, puisqu'on n'est pas certain qu'elle apparaît dans l'historique


        return route.chemin === '/' ? /*#__PURE__*/_react.default.createElement("li", {
          key: "fil-ariane-".concat(i)
        }, /*#__PURE__*/_react.default.createElement(_MfaLien.MfaLien, {
          to: route.chemin
        }, /*#__PURE__*/_react.default.createElement("span", null, route.description))) : /*#__PURE__*/_react.default.createElement("li", {
          key: "fil-ariane-".concat(i)
        }, /*#__PURE__*/_react.default.createElement(_MfaLien.MfaLien, {
          onClick: function onClick() {
            return _this2.props.history.go(-(parents.length - i));
          }
        }, /*#__PURE__*/_react.default.createElement("span", null, route.description)));
      }), /*#__PURE__*/_react.default.createElement("li", {
        key: "fil-ariane-".concat(parents.length)
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "curitem"
      }, routeCourante.description))), /*#__PURE__*/_react.default.createElement("div", {
        className: "filArianeFermeture"
      }, (0, _dist.estDefini)(this.props.fermetureSessionInfo) ? /*#__PURE__*/_react.default.createElement(_MfaBouton.MfaBouton, {
        className: "marge-h",
        estSecondaire: true,
        taille: this.props.fermetureSessionInfo.taille,
        onClick: this.confirmerFermetureSession
      }, this.props.fermetureSessionInfo.description) : null)), /*#__PURE__*/_react.default.createElement(_MfaDialogue.MfaDialogue, {
        estVisible: this.state.afficherFermetureAvert,
        surAnnulation: this.annulerFermetureSession,
        surSortie: this.fermerSession,
        titre: this.props.fermetureSessionInfo.titre,
        message: this.props.fermetureSessionInfo.message,
        messageboutonAnnulation: this.props.fermetureSessionInfo.messageboutonAnnulation,
        messageboutonSortie: this.props.fermetureSessionInfo.messageboutonSortie,
        nomIcone: "warning sign"
      }));
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextProps.location.key !== this.props.location.key) {
        var chemin = nextProps.location.pathname.replace(/\/$/, '');

        if (nextProps.history.action === 'PUSH') {
          this.ajouterRoute(chemin, nextProps.location.key);
        } else if (nextProps.history.action === 'REPLACE') {
          this.remplacerRoute(chemin, nextProps.location.key);
        } else if (nextProps.history.action === 'POP') {
          this.retourRoute(chemin, nextProps.location.key);
        }

        return true;
      } else if ((0, _dist.estDefini)(nextState.afficherFermetureAvert)) {
        return true;
      }

      return false;
    }
  }, {
    key: "ajouterRoute",
    value: function ajouterRoute(chemin, cle) {
      var indexCourant = this.obtenirIndexCourant(this.props.location.key);

      if (this.state.routeHistory.length > indexCourant + 1) {
        this.state.routeHistory.splice(indexCourant + 1, this.state.routeHistory.length - indexCourant - 1);
      }

      var route = this.obtenirRoute(chemin);
      this.state.routeHistory.push({
        route: route,
        cle: cle
      });
    }
  }, {
    key: "obtenirIndexCourant",
    value: function obtenirIndexCourant(cle) {
      var historique = this.state.routeHistory.filter(function (h) {
        return h.cle === cle;
      });

      if (!historique || historique.length === 0) {
        return -1;
      }

      return this.state.routeHistory.indexOf(historique[0]);
    }
  }, {
    key: "obtenirRoute",
    value: function obtenirRoute(chemin) {
      return this.props.routes.filter(function (route) {
        return !!(0, _reactRouter.matchPath)(chemin, {
          path: route.chemin,
          exact: true,
          strict: false
        });
      }).find(function (e) {
        return true;
      });
    }
  }, {
    key: "remplacerRoute",
    value: function remplacerRoute(chemin, cle) {
      //Cas d'exception pour le redirect initial de la page d'accueil
      if (this.state.routeHistory.length === 0) {
        this.ajouterRoute(chemin, cle);
      } else {
        var indexCourant = this.obtenirIndexCourant(this.props.location.key);
        var route = this.obtenirRoute(chemin);
        this.state.routeHistory[indexCourant] = {
          route: route,
          cle: cle
        };
      }
    }
  }, {
    key: "retourRoute",
    value: function retourRoute(chemin, cle) {
      var indexCourant = this.obtenirIndexCourant(cle);

      if (indexCourant === -1) {
        this.state.routeHistory = [];
        this.ajouterRoute(chemin, cle);
      }
    }
  }]);

  return MfaEnteteFilAriane;
}(_react.Component);

var _default = (0, _reactRouter.withRouter)(MfaEnteteFilAriane);

exports.default = _default;